export const XTeamRole = {
  LEAD_TECHNICIAN: "LEAD_TECHNICIAN",
  TECHNICIAN: "TECHNICIAN"
};
